import { IOwner } from 'src/features/owner/ts/interfaces/Owner';
import { ICompany, IProperty, IPropertyFeature } from 'src/ts/interfaces';
import PropertyFormNew from './PropertyFormNew';

export type PropertyFormProps = {
  defaultValues?: IProperty;
  company?: ICompany | null;
  onSave: (formData: IProperty) => void;
  isCreateForm?: boolean;
  isAdmin?: boolean;
  isFieldDisabled?: boolean;
  propertyFeatures?: IPropertyFeature[];
  isDupDisabled?: boolean;
  owner?: IOwner;
  settingsLink?: string | null;
  areFeaturesReadOnly?: boolean;
};

const PropertyFormWrapper = (props: PropertyFormProps) => {
  return <PropertyFormNew {...props} />;
};

export default PropertyFormWrapper;
